module.exports = __webpack_public_path__ + "fb6c16724fb2b0f5568c73f32c64a673.png";